import { useUser } from '../context/UserContext';

function MaintenancePage() {
  return (
    <div className="max-w-lg mx-auto px-4 py-24 flex flex-col items-center text-center">
      <div className="bg-surface rounded-clay shadow-clay dark:shadow-clay-dark border border-surface p-10 flex flex-col items-center gap-5 w-full">
        <div className="p-3 rounded-full bg-amber-50 dark:bg-amber-900/20">
          <svg className="w-8 h-8 text-amber-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M11.42 15.17L17.25 21A2.652 2.652 0 0021 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 11-3.586-3.586l5.654-4.654m5.546-4.179l2.18-2.18a2.625 2.625 0 113.712 3.713L17.5 10.5m-5.546 4.179l2.496-3.03c.317-.384.74-.626 1.208-.766M6.75 7.5l.75 3.75m0 0l.75 3.75M7.5 11.25h3.75m-3.75 0h-3.75" />
          </svg>
        </div>
        <h1 className="text-xl font-semibold text-neutral-800 dark:text-neutral-100">
          Under Maintenance
        </h1>
        <p className="text-sm text-neutral-500 dark:text-neutral-400 max-w-sm">
          This feature is temporarily unavailable while we make improvements. Please check back shortly.
        </p>
      </div>
    </div>
  );
}

export default function ProtectedRoute({ featureKey, children }) {
  const { features, loading } = useUser();
  if (loading) return null;
  if (features[featureKey] === false) return <MaintenancePage />;
  return children;
}
